export const filterBarStyles = `
  .filter-bar {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 12px;
    flex-wrap: wrap;
  }
  .filter-bar__field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 100px;
  }
  .filter-bar__field--narrow {
    flex: 0 0 110px;
  }
  .filter-bar__label {
    font-size: 11px;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
  }
  .filter-bar__input {
    height: 34px;
    padding: 0 10px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 13px;
    color: #111827;
    background: #ffffff;
    outline: none;
    width: 100%;
    box-sizing: border-box;
  }
  .filter-bar__input:focus {
    border-color: #6b7280;
  }
  .filter-bar__clear {
    height: 34px;
    padding: 0 14px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #ffffff;
    color: #374151;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    align-self: flex-end;
  }
  .filter-bar__clear:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
  }
  .filter-bar .button-group {
    align-self: flex-end;
  }
  .filter-bar .button-group .button {
    margin-bottom: 0;
    height: 34px;
  }
`;

export default filterBarStyles;
